import React from 'react';
import { Leaf, GraduationCap, GenderFemale } from '@phosphor-icons/react';

const RainbowHeart = ({ size = 13, weight, ...props }) => {
  const gradientId = React.useId();
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ef4444" /><stop offset="17%" stopColor="#f97316" />
          <stop offset="34%" stopColor="#facc15" /><stop offset="51%" stopColor="#22c55e" />
          <stop offset="68%" stopColor="#3b82f6" /><stop offset="85%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#d946ef" />
        </linearGradient>
      </defs>
      <path d="M12 21s-9-5.6-9-12a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 6.4-9 12-9 12Z" fill={`url(#${gradientId})`} stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
};

export const STARTUP_BADGES = [
  {
    id: 'lgbtqai_plus',
    label: 'LGBTQIA+',
    description: 'LGBTQIA+ founder or leadership representation',
    icon: RainbowHeart,
    classes: 'bg-fuchsia-500/10 text-fuchsia-600 dark:text-fuchsia-300 border-fuchsia-500/20',
  },
  {
    id: 'women_led',
    label: 'Women-Led',
    description: 'Woman-led founding or leadership team',
    icon: GenderFemale,
    classes: 'bg-violet-500/10 text-violet-600 dark:text-violet-300 border-violet-500/20',
  },
  {
    id: 'student',
    label: 'Student-Led',
    description: 'Founded or currently led by a student founder',
    icon: GraduationCap,
    classes: 'bg-blue-500/10 text-blue-600 dark:text-blue-300 border-blue-500/20',
  },
  {
    id: 'sustainable',
    label: 'Sustainable',
    description: 'Sustainability is a meaningful part of the company',
    icon: Leaf,
    classes: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20',
  },
];

export const STARTUP_BADGE_IDS = STARTUP_BADGES.map((badge) => badge.id);

export const getStartupBadge = (id) => STARTUP_BADGES.find((badge) => badge.id === id);

const StartupBadges = ({ badges = [], size = 'sm', className = '', iconOnly = false }) => {
  const badgeIds = Array.isArray(badges) ? badges : typeof badges === 'string' ? [badges] : [];
  const validBadges = [...new Set(badgeIds)].map(getStartupBadge).filter(Boolean);
  if (!validBadges.length) return null;

  const sizeClasses = size === 'xs'
    ? 'text-[10px] px-1.5 py-0.5 gap-1'
    : 'text-[11px] px-2 py-1 gap-1.5';
  const iconSize = size === 'xs' ? 11 : 13;

  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="startup-badges">
      {validBadges.map(({ id, label, icon: Icon, classes }) => (
        <span
          key={id}
          title={iconOnly && id === 'student' ? 'Student-Led' : label}
          aria-label={iconOnly ? (id === 'student' ? 'Student-Led' : label) : undefined}
          className={`inline-flex items-center rounded-full border font-medium whitespace-nowrap ${sizeClasses} ${classes}`}
          data-testid={`startup-badge-${id}`}
        >
          <Icon size={iconSize} weight="bold" aria-hidden="true" />
          {!iconOnly && label}
        </span>
      ))}
    </div>
  );
};

export default StartupBadges;
